import authService from '../api/authService';

/** Roles that use agent chat queue + pending-requests API */
const AGENT_ROLE_CODES = new Set([
  'AGENT',
  'TEAM_LEAD',
  'ADMIN',
  'SUPER_ADMIN',
  'SUPERADMIN',
  'DEVELOPER'
]);

/**
 * True when user has a JWT and a staff role that should call agent chat APIs.
 * (Avoids 401 on /signin or customer portal.)
 */
export function isAuthenticatedAgentStaff() {
  const token = sessionStorage.getItem('token') || sessionStorage.getItem('authToken');
  if (!token) return false;

  const u = authService.getCurrentUser();
  if (!u) return false;

  const code = String(u.roleCode || '')
    .toUpperCase()
    .replace(/-/g, '_');
  if (AGENT_ROLE_CODES.has(code)) return true;

  const r = String(u.role || '')
    .toLowerCase()
    .replace(/-/g, '_');
  return ['agent', 'team_lead', 'admin', 'super_admin', 'developer'].includes(r);
}
